import { UserApiFactory } from 'generated';
import { instanceApi } from 'utils/axios';
import useRequest from 'api/useRequest';

const userApi = UserApiFactory(undefined, '', instanceApi);

export const useUserInfo = () => useRequest(userApi.ngmUserInfo, []);

export default userApi;
